import PromoPreview from "components/PromoPreview";
import { BulletpointsProductModel, ProductProps, WebshopProductModel } from "models/WebShop";
import { DragEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const BulletpointsProduct = ({ handleAddProduct, handleFormValidation, initialProduct }: ProductProps) => {
    const params = useParams();

    const defaultProduct : BulletpointsProductModel = {
        bulletpoints: [],
        webShopProductId: 102,
        documentId: params.id ?? "",
        path: "",
        name: "Punktliste: Bedriftens varer og tjenester",
        payload: "",
        id: params.id ? params.product + params.id : "",
        description: "",
        linkText: "",
        price: 1500,
        basePrice: 1500,
    }

    const [bulletpoints, setBulletpoints] = useState<string[]>(
        initialProduct?.bulletpoints ?? ['', '', '', '', '']
    );

    const handleDragStart = (e: React.DragEvent<HTMLLIElement>, index: number) => {
        e.dataTransfer.setData('dragIndex', index.toString());
    };

    const handleDrop = (e: React.DragEvent<HTMLLIElement>, dropIndex: number) => {
        const dragIndex = parseInt(e.dataTransfer.getData('dragIndex'), 10);
        const newItems = [...bulletpoints];
        const [draggedItem] = newItems.splice(dragIndex, 1);
        newItems.splice(dropIndex, 0, draggedItem);
        setBulletpoints(newItems);

        if (newItems.every(item => item === '')){
            handleFormValidation(false)
        }
        else{
            handleFormValidation(true);
        }
        addAction(newItems);
    };

    const handleInputChange = (index: number, value: string) => {
        const newItems = [...bulletpoints];
        newItems[index] = value;

        if (newItems.every(item => item === '')){
            handleFormValidation(false)
        }
        else{
            handleFormValidation(true);
        }

        setBulletpoints(newItems);
        addAction(newItems);
    };

    const addAction = (value:string[]) => {

        const updatedProduct: BulletpointsProductModel = {
            ...defaultProduct,
            bulletpoints: value,
        };
        handleAddProduct(updatedProduct);
    };

    return (
        <>
            <p className="text-muted d-none d-lg-inline">
                Maks 30 tegn i hvert listeelement. Dra og slipp for å endre rekkefølge.
            </p>

            <div className="mb-4">
                <ul className="cc-draggable-list list-unstyled">

                    {bulletpoints.map((text, index) => (
                        <li
                            key={index}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, index)}
                            className="d-flex align-items-center gap-2 mb-2"
                        >
                            <span className="cc-drag-handle d-none d-lg-inline">⠿</span>
                            <div className="cc-draggable-list-disc">
                                <input
                                    type="text"
                                    className="form-control border-primary border-opacity-25"
                                    maxLength={30}
                                    value={text}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    aria-label={`Punktliste tekst ${index + 1}`}
                                />
                            </div>
                        </li>
                    ))}

                </ul>
            </div>
            <PromoPreview id={params.id ?? ""} bulletpoints={bulletpoints.filter(x => x !== "").toString()}/>
        </>
    );
};


export default BulletpointsProduct;